import useApiQuery from 'shared/hooks/use-api-query';
import {CategoryProps} from '../types';
import useAccessControls from 'modules/access-controls/atoms/use-access-controls';

const useCategoriesSelect = () => {
  const {companyId} = useAccessControls();

  const {data = [], ...rest} = useApiQuery<CategoryProps[]>({
    url: '/categories/all',
  });

  return {
    ...rest,
    data: data?.map((category) => ({
      label: !companyId
        ? `${category.name} - ${category.company?.name}`
        : category.name,
      value: category.id,
    })),
  };
};

export default useCategoriesSelect;
